module.exports = __webpack_public_path__ + "img/scene_christmas_big@2x.92fed2ce.png";